import { render, staticRenderFns } from "./LatestRides.vue?vue&type=template&id=fc2adf1c&scoped=true&"
import script from "./LatestRides.vue?vue&type=script&lang=js&"
export * from "./LatestRides.vue?vue&type=script&lang=js&"
import style0 from "./LatestRides.vue?vue&type=style&index=0&id=fc2adf1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2adf1c",
  null
  
)

export default component.exports